<template>
  <div class="new">
    <div class="new__title">
      <template v-if="progressActiveIndex != 1">
        选品利润预算
      </template>
      <template v-else>
        新建选品利润预算
      </template>
      <div class="new__tips">(注：对于已确定要销售的商品，请转到"在售商品与店铺利润预算"目录中创建)</div>
    </div>
    <div class="new-top">
      <div class="new-top__name">
        汇率更新时间({{ budgetProfitData.rateTime }})
        {{ countryAbbreviationArray[budgetProfitData.countrySite] }}/RMB即时汇率:
        <span class="new-top__value">{{ budgetProfitData.rate[budgetProfitData.countrySite] }}</span>
      </div>
      <div class="new-top__name">
        {{ sellerTypeTextArray[budgetProfitData.sellerType] }}卖家帐户月费:
        <span class="new-top__tip">({{ countryCurrencyArray[0] }})</span>
        <span class="new-top__value">
          <template v-if="!budgetProfitData.sellerType">$39.99/月</template>
          <template v-else>$0/月</template>
        </span>
      </div>
      <div class="new-top__name">
        当月仓储费:
        <span class="new-top__tip">
          ({{ countryCurrencyArray[budgetProfitData.countrySite] }})
        </span>
        <span class="new-top__value">
          {{ nationalCurrencyArray[budgetProfitData.countrySite] }}{{ budgetProfitData.monthlyStorageFee }}/m³
        </span>
      </div>
    </div>
    <progressBar
      class="new-progress"
      :arr="progressData"
      :activeIndex="progressActiveIndex"></progressBar>
    <div class="new-input">
      <div class="new-input__title">亚马逊FBA商品原始数据</div>
      <div class="new-input-module">
        <div class="new-input-module-item">
          <div class="new-input-module__item">
            <div class="new-input-module__name">商品图片:</div>
            <div class="new-input-module-img"
              :class="{'input--prompt': isPromptInput && !budgetProfitData.img}">
              <template v-if="!budgetProfitData.img">
                <div class="new-input-module-img__add"></div>
                <input type="file" id="image" class="new-input-module-img__input" @change="uploadImg()">
                <div class="new-input-module-img__text">（添加图片）</div>
              </template>
              <template v-else>
                <div class="new-input-module-img__close" @click="removeImg()" v-if="!isDisable"></div>
                <img :src="'/api/support-server/v1/fileInfo/downloadFile/' + budgetProfitData.img" alt="" class="new-input-module-img__image">
              </template>
            </div>
          </div>
          <div class="new-input-module__item">
            <div class="new-input-module__name">商品名称:</div>
            <input type="text" class="new-input-module__input"
              v-model="budgetProfitData.name"
              :disabled="isDisable"
              :class="{'input--prompt': isPromptInput && !budgetProfitData.name, 'input--disable': isDisable}">
          </div>
          <div class="new-input-module__item">
            <div class="new-input-module__name">商品备注: <span class="new-input-module__name--tips">(非必填项)</span></div>
            <input type="text" class="new-input-module__input"
              v-model="budgetProfitData.remark"
              :disabled="isDisable"
              :class="{'input--disable': isDisable}">
          </div>
        </div>
        <inputModule
          :budget-profit-data="budgetProfitData"
          :is-prompt="isPromptInput"
          :is-show-result="true"
          :is-disable="isDisable"
          inputType="store"
          @openTaxDialog="changeTaxDialogShow({ type: 'input', bool: true })"
          @budgetChange="changeBudgetComponentData"></inputModule>
      </div>
    </div>
    <div class="new-cal__divider" v-show="progressActiveIndex === 2 || progressActiveIndex === 3">选品利润预算分析:</div>
    <div class="new-cal" v-show="progressActiveIndex === 2 || progressActiveIndex === 3">
      <div class="new-cal-left">
        <div class="new-cal__title">单位商品成本与费用分摊</div>
        <div class="new-cal-left-module">
          <div class="new-cal__block"
            v-for="(item, index) in budgetCostCalData"
            :key="index">
            <div class="new-cal__line"
              v-for="(input, i) in item.input"
              :key="input.data">
              <div class="new-cal__name"
                :class="{'new-cal__name--selected' : input.html && input.showDetail}">
                {{ input.name }}
                <template v-if="input.html">
                  <img src="../img/问号.png" alt=""
                    class="new-cal__img"
                    @mouseover="showDetailHtml(index, i)"
                    @mouseleave="cancelDetailHtml(index, i)">
                  <div
                    class="new-cal__detail"
                    v-html="input.html"
                    v-show="input.showDetail"></div>
                </template>
              </div>
              <div class="new-cal__value">
                <i class="el-icon-loading new-cal__icon" v-show="input.isRefresh"></i>
                ￥{{ keepDecimalPoint(budgetProfitData[input.data], input.decimal) }}{{ getUnitEnum(input.unit) }}
              </div>
              <template v-if="input.data === 'getComprehensiveTaxesAndFeesOfTheImportingCountry'">
                <div class="new-cal__down" @click="changeTaxDialogShow({ type: 'dialog', bool: true })"></div>
              </template>
            </div>
          </div>
        </div>
        <div class="new-cal-bottom">
            <div class="new-cal-bottom__left">成本汇总：</div>
            <div class="new-cal-bottom__right">
              <!-- 卖家账户固定费用 -->
              <div v-if="false">
                <div class="new-cal-bottom__btn"
                  :style="{ background: budgetProfitData.calType ? '#99D8E7' : '' }"
                  @click="inputChangeInformUp($event, 'calType', (Number(budgetProfitData.calType) + 1) % 2)">
                  <template v-if="budgetProfitData.calType">计算卖家账户固定费用</template>
                  <template v-else>忽略卖家账户固定费用</template>
                </div>
              </div>
              ￥{{ keepDecimalPoint(budgetProfitData.getCostSummary, 1) }}{{ getUnitEnum('perUnit') }}
            </div>
        </div>
      </div>
      <div class="new-cal-right">
        <div class="new-cal__title">当月销售额,收汇,利润及利润率</div>
        <div class="new-cal__line1"
          v-for="(item, index) in budgetedProfitCalData"
          :key="item.data">
          <div class="new-cal__name"
            :class="{'new-cal__name--selected' : item.html && item.showDetail}">
            {{ item.name }}
            <span class="new-cal__tip" v-if="item.data === 'getActualSalesVolumeForTheMonth'">(扣减退货)</span>
            <template v-if="item.html">
              <img src="../img/问号.png" alt=""
                class="new-cal__img"
                @mouseover="showDetailHtml(index)"
                @mouseleave="cancelDetailHtml(index)">
              <div class="new-cal__detail new-cal__detail1" v-html="item.html" v-show="item.showDetail"></div>
            </template>
          </div>
          <div class="new-cal__value">
            <template
              v-if="item.data !== 'getActualSalesVolumeForTheMonth'
              && item.data !== 'getMonthlySalesProfitMargin'
              && item.data !== 'getMonthlyCostProfitMargin'">￥
            </template>{{ keepDecimalPoint(budgetProfitData[item.data], item.decimal) }}{{ getUnitEnum(item.unit) }}
            <template
              v-if="item.data === 'getMonthlySalesProfitMargin'
              || item.data === 'getMonthlyCostProfitMargin'">%
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="new-fun">
      <template v-if="progressActiveIndex === 1">
        <div class="new-fun__btn" @click="clearData()">清空数据</div>
        <div class="new-fun__btn" @click="clamData()">选品利润预算</div>
      </template>
      <template v-if="isDisable">
        <div class="new-fun__btn" @click="isDisable = !isDisable">修改</div>
      </template>
      <template v-else>
        <template v-if="progressActiveIndex !== 1">
          <div class="new-fun__btn" @click="goBack()">返回上一步</div>
        </template>
        <template v-if="progressActiveIndex === 2">
          <div class="new-fun__btn" @click="SaveData()">保存预算数据</div>
        </template>
        <template v-if="progressActiveIndex === 3">
          <div class="new-fun__btn" @click="changeData()">保存</div>
        </template>
      </template>
    </div>
    <el-dialog
      :visible.sync="showTaxDialog"
      width="650px"
      :append-to-body="true">
      <div class="calm-tax__title">
        {{ taxDialogData.title }} <span class="calm-tax__subtitle">({{ sqbsInputOptions[budgetProfitData.sqbs] }})</span>
      </div>
      <div class="calm-tax">
        <div class="calm-tax__module">
          <div class="calm-tax__line" v-for="(item, index) in taxDialogData.input" :key="item.data">
            <div class="calm-tax__name">
              {{ item.name }}
              <template v-if="item.html">
                <img src="../img/问号.png" alt=""
                  class="calm-tax__img"
                  @mouseover="showTaxDetailHtml(index)"
                  @mouseleave="cancelTaxDetailHtml(index)">
                <div
                  class="calm-tax__detail"
                  :class="{'calm-tax__detail1': item.data === 'getTaxRefund'}"
                  v-html="item.html"
                  v-show="item.showDetail"></div>
              </template>
            </div>
            <div class="calm-tax__right">
              <div class="calm-tax__value">
                <template
                v-if="item.data === 'getSalesVATOnGoods'
                  || (item.data === 'getTaxRefund' && budgetProfitData.sqbs == 1)
                  || (item.data === 'getImportTariffsOnGoods' && budgetProfitData.sqbs == 0 )">
                  ￥0.00
                  <div
                    class="calm-tax__value--underline"
                    :class="{'calm-tax__value--underline1': typeTaxDialog != 'dialog'}"
                    v-if="budgetProfitData.sqbs == 1">
                    ￥{{ keepDecimalPoint(budgetProfitData[item.data]
                    * (typeTaxDialog == 'dialog' ? 1 : budgetProfitData.getCalculateBasedOnActualSalesVolume), 2)}}
                  </div>
                </template>
                <template v-else>
                  ￥{{ keepDecimalPoint(budgetProfitData[item.data]
                  * (typeTaxDialog == 'dialog' ? 1 :
                    item.data == 'getValueAddedTaxOnSalesOfGoods' ? budgetProfitData.stockNum : budgetProfitData.getCalculateBasedOnActualSalesVolume), 2)}}
                </template>
                <template v-if="typeTaxDialog != 'input'">{{ getUnitEnum('perUnit') }}</template>
              </div>
              <div class="calm-tax__pla">{{ item.pla }}</div>
            </div>
          </div>
          <div class="calm-tax__remark" v-if="taxDialogRemarkText !== ''">
            {{ taxDialogRemarkText }}
          </div>
        </div>
        <div class="calm-tax__line">
          <div class="calm-tax__name">{{ taxDialogDataLast.name }}</div>
          <div class="calm-tax__right">
            <div class="calm-tax__value">
              <template>
                ￥{{ keepDecimalPoint(typeTaxDialog == 'dialog'?
                  budgetProfitData[taxDialogDataLast.data] : budgetProfitData.importTariff, 2) }}
              </template>
              <template v-if="typeTaxDialog != 'input'">{{ getUnitEnum('perUnit') }}</template>
            </div>
            <div class="calm-tax__pla">{{ taxDialogDataLast.pla }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { BudgetProfit, ProfitFromProductSelectNewModule } from './class'
import { summaryTab } from "common/dataClass/Summary";
import { ProfitInputNewModule, INPUTENUM } from "common/dataClass/Profit";
import globalData from "common/globalData";
import progressBar from 'components/common/progressBar';
import inputModule from 'views/calm/component/content/inputModule.vue';
import DefaultAxios from 'service/default'
import ProfitAxios from 'service/profit'
export default {
  name: 'newProfitFromProductSelection',
  components: {
    progressBar, inputModule
  },
  data(){
    return {
      /**货币数组 */
      countryCurrencyArray: globalData.countryCurrencyInvariant,
      /**货币缩写 */
      nationalCurrencyArray: globalData.nationalCurrencyInvariant,
      /**国家缩写 */
      countryAbbreviationArray: globalData.countryAbbreviationInvariant,
      /**卖家账户类型文字数组 */
      sellerTypeTextArray: globalData.sellerTypeInputOptions.map(s => s.slice(0, -2)),
      /**会员会费 */
      warehouseFeeArray: globalData.warehouseFee,
      /**预算计算基础数据 */
      budgetProfitData: new BudgetProfit(),
      /**是否提示未输入数据的输入框 */
      isPromptInput: false,
      /**预算成本显示数据 */
      budgetCostCalData: ProfitInputNewModule.NEWCAL(),
      /**预算利润显示数据 */
      budgetedProfitCalData: ProfitInputNewModule.NEWPROFIT(),
      /**进度条数据 */
      progressData: ProfitFromProductSelectNewModule.NEWPROGRESSARRAY(),
      progressActiveIndex: 1,
      /**是否能修改 */
      isDisable: false,
      /**是否显示税务弹窗 */
      showTaxDialog: false,
      typeTaxDialog: '',
      /**税务弹窗数据 */
      taxDialogData: {},
      taxDialogDataLast: {},
      taxDialogRemarkText: '',
      /**双清包税选择项 */
      sqbsInputOptions: globalData.sqbsInputOptions,
    }
  },
  methods:{
    /**保留小数点数位 */
    keepDecimalPoint: globalData.keepDecimalPoint,
    /**组件修改预算数据 */
    changeBudgetComponentData(obj){
      if(!obj) return
      this.budgetProfitData[obj.key] = obj.value
    },
    /**上传图片 */
    async uploadImg(){
      /**图片最大限制 */
      let imgMaxSize = 1 * 1024 * 1024;
      let file = document.getElementById('image').files[0]
      if(file.size > imgMaxSize){
        this.$message.error('文件不能大于1M！')
        return
      }
      if(!/image\/\w+/.test(file.type)){
        this.$message.error('文件必须为图片！')
        return
      }
      if(!file) return;
      let res = await DefaultAxios.uploadImg(file)
      if(res.data.code === 1){
        this.$message.success('上传成功')
        this.budgetProfitData.img = res.data.info.fileId
      }
    },
    /**删除图片 */
    removeImg(){
      this.budgetProfitData.img = ''
    },
    /**清空数据 */
    clearData(){
      this.budgetProfitData.clearData()
      this.isPromptInput = false
    },
    /**选品利润计算 */
    clamData(){
      let arr = this.budgetProfitData.needArray()
      let bool = arr.some(key => {
        console.log(key, this.budgetProfitData[key], !this.budgetProfitData[key]);
        return !this.budgetProfitData[key] && this.budgetProfitData[key] != 0
      })
      if(bool){
        this.isPromptInput = true
        this.$message.error('请将数据补充完整')
        return;
      }
      this.progressActiveIndex ++
    },
    /**获取对应的枚举单位 */
    getUnitEnum(unit){
      if(unit === INPUTENUM.NONE) return ''
      let arr = INPUTENUM.judgeEnumReturnString[unit]
      return arr[this.budgetProfitData.unit ? this.budgetProfitData.unit : 0]
    },
    /**鼠标停留在对应的输入框名称上 */
    showDetailHtml(index, i = null){
      const _this = this
      this.detailTimer = setTimeout(() => {
        i !== null ?
          _this.budgetCostCalData[index].input[i].showDetail = true :
          _this.budgetedProfitCalData[index].showDetail = true
      }, 500);
    },
    showTaxDetailHtml(index){
      const _this = this
      this.detailTimer = setTimeout(() => {
        _this.taxDialogData.input[index].showDetail = true
      }, 500)
    },
    /**鼠标离开对应的输入框名称上 */
    cancelDetailHtml(index, i = null){
      clearTimeout(this.detailTimer)
      this.detailTimer = null
      i !== null ?
        this.budgetCostCalData[index].input[i].showDetail = false :
        this.budgetedProfitCalData[index].showDetail = false
    },
    cancelTaxDetailHtml(index){
      clearTimeout(this.detailTimer)
      this.detailTimer = null
      this.taxDialogData.input[index].showDetail = false
    },
    /**返回上一步 */
    goBack(){
      this.progressActiveIndex = this.progressActiveIndex - 1
    },
    /**保存预算数据 */
    async SaveData(){
      let data = this.budgetProfitData.getNewProductBudgetAxiosBody
      let storeConfig = this.$store.state.storeList[data.storeId]
      data.storeId = storeConfig.id
      try {
        let res = await ProfitAxios.newProductBudget(data)
        if(res.data.code === 1){
          this.$message.success(res.data.info)
          this.returnBudgetPage()
        }else{
          this.$message.error(res.data.info)
        }
      } catch (error) {
        this.$message.error(error)
      }
    },
    /**保存修改的数据 */
    async changeData(){
      let data = this.budgetProfitData.getUpdateProductBudgetAxiosBody
      let storeConfig = this.$store.state.storeList[data.storeId]
      data.storeId = storeConfig.id
      try {
        let res = await ProfitAxios.updateProductBudget(data)
        if(res.data.code === 1){
          this.$message.success(res.data.info)
          this.returnBudgetPage()
        }else{
          this.$message.error(res.data.info)
        }
      } catch (error) {
        this.$message.error(error)
      }
    },
    /**返回选品利润预算页面 */
    returnBudgetPage(){
      let tab = new summaryTab('选品利润预算', 'profitFromProductSelection')
      this.$emit('delete', {id : 'newProfitFromProductSelection', tab: tab})
    },
    /**税务弹窗开关 */
    changeTaxDialogShow(obj){
      this.typeTaxDialog = obj.type
      let firstStr = this.typeTaxDialog == 'input' ? '' : '单位'
      this.taxDialogData.title = firstStr + '商品入口国综合税'
      this.taxDialogDataLast.name = firstStr + '商品入口国综合税'
      this.showTaxDialog = obj.bool
    },
  },
  computed:{
    rate(){
      return {
        rates: this.$store.state.rate.rates,
        refreshTime: this.$store.state.rate.refreshTime
      }
    },
    presetBasicData(){
      return {
        countrySite: this.budgetProfitData.countrySite,
        store: this.budgetProfitData.store
      }
    },
    type(){
      return this.$store.state.newProfitFromProductSelection.type
    },
    id(){
      return this.$store.state.newProfitFromProductSelection.id
    },
    /**判断税务弹窗文字是否需要修改 */
    changeTaxDialogDataBody(){
      let obj = {
        'countrySite': this.budgetProfitData.countrySite,
        'xxts': this.budgetProfitData.xxts,
        'sqbs': this.budgetProfitData.sqbs
      }
      return obj
    },
  },
  watch:{
    rate: {
      immediate: true,
      handler(newVal){
        this.budgetProfitData.setRate(newVal)
      }
    },
    presetBasicData:{
      handler(newVal){
        let countrySite = newVal.countrySite
        let store = newVal.store
        let storeConfig = this.$store.state.storeList[store]
        let financeFee = storeConfig.configMap.financeFees.find(obj => obj.countrySite == globalData.countryAbbreviationInvariantByFinancial[countrySite])
        let operationFee = storeConfig.configMap.operationFee
        let otherFee = storeConfig.configMap.otherFee
        let softwareFee = storeConfig.configMap.softwareFee
        this.budgetProfitData.sellerType = storeConfig.configMap.sellerType
        this.budgetProfitData.warehouseConfiguration = storeConfig.configMap.mergeConfiguration
        this.budgetProfitData.otherFee = operationFee + otherFee + softwareFee
        this.budgetProfitData.taxExpense = financeFee ? financeFee.fee : 0
        this.budgetProfitData.operatingAnnualInterestRate = storeConfig.configMap.operationInterestRateYearly
      }
    },
    type: {
      immediate: true,
      handler(newVal){
        let obj = {
          new: () => {
            this.progressActiveIndex = 1
            this.isDisable = false
          },
          change: () => {
            this.isDisable = true
            let value = JSON.parse(this.$store.state.newProfitFromProductSelection.value)
            let store = this.$store.state.storeList
            let profitFromProductKeys = Object.keys(this.budgetProfitData)
            profitFromProductKeys.map(key => {
              this.budgetProfitData[key] = value[key]
              if(key == 'store'){
                this.budgetProfitData.store = store.findIndex(obj => obj.id == value.store)
              }
            })
            this.budgetProfitData.id = this.$store.state.newProfitFromProductSelection.id
            this.budgetProfitData.xxts = 0
            this.budgetProfitData.sqrkgsl = 0
            this.budgetProfitData.laborCostForStoreManagement = 100
            this.progressActiveIndex = 3
          }
        }
        obj[newVal]()
      }
    },
    changeTaxDialogDataBody:{
      immediate: true,
      handler(newVal){
        let arr1 = globalData.europeIndexArray
        let arr2 = globalData.europeAndAmericaIndexArray
        let arr3 = globalData.aisaIndexArray
        if(arr1.includes(newVal.countrySite)){
          this.taxDialogData = ProfitInputNewModule.NEWTAXDATAEUROPE()
          if(newVal.sqbs == 0){
            this.taxDialogRemarkText = globalData.taxDialogRemarkText7
            this.taxDialogData.input[0].pla = '(物流公司自缴)'
            this.taxDialogData.input[1].pla = '(物流公司自缴或申请递延)'
            this.taxDialogData.input[2].pla = '(物流公司自缴)'
            this.taxDialogData.input[4].pla = '(税务链箱断裂,不能退补税)'
          }else{
            this.taxDialogRemarkText = ''
            this.taxDialogData.input[0].pla = '(以自己税号自缴)'
            this.taxDialogData.input[1].pla = '(默认申请递延成功)'
            this.taxDialogData.input[2].pla = '(以自己税号自缴)'
            this.taxDialogData.input[4].pla = this.budgetProfitData.getTaxRefund > 0 ? '(无申请递延才可补税)': '(无申请递延才可退税)'
          }
          // 澳洲将 VAT 替换成 GST, 并清掉(ADV)
          if(this.budgetProfitData.countrySite == 8){
            for(let i = 0; i < this.taxDialogData.input.length; i ++){
              this.taxDialogData.input[i].name = globalData.replaceAll(this.taxDialogData.input[i].name, '(ADV)', '')
              this.taxDialogData.input[i].name = globalData.replaceAll(this.taxDialogData.input[i].name, 'VAT', 'GST')
              this.taxDialogData.input[i].html = globalData.replaceAll(this.taxDialogData.input[i].html, 'VAT', 'GST')
              this.taxDialogRemarkText = globalData.replaceAll(this.taxDialogRemarkText, 'VAT', 'GST')
            }
          }else if(this.budgetProfitData.countrySite == 9){  // 墨西哥将 VAT 替换成 IVA, 并清掉(ADV)
            for(let i = 0; i < this.taxDialogData.input.length; i ++){
              this.taxDialogData.input[i].name = globalData.replaceAll(this.taxDialogData.input[i].name, '(ADV)', '')
              this.taxDialogData.input[i].name = globalData.replaceAll(this.taxDialogData.input[i].name, 'VAT', 'IVA')
              this.taxDialogData.input[i].html = globalData.replaceAll(this.taxDialogData.input[i].html, 'VAT', 'IVA')
              this.taxDialogRemarkText = globalData.replaceAll(this.taxDialogRemarkText, 'VAT', 'IVA')
            }
          }
          // if(newVal.xxts == 0){
          //   // 直接调用filter无法改变Objcet属性的指向，需要使用defineProperty
          //   Object.defineProperty(this.taxDialogData, 'input', {
          //     value: this.taxDialogData.input.filter(v => v.data !== 'getTaxRefund')
          //   })
          // }
        }else if(arr2.includes(newVal.countrySite)){
          this.taxDialogData = ProfitInputNewModule.NEWTAXDATAEUROPEANDAMERICE()
          if(newVal.sqbs == 0){
            if(newVal.countrySite == 0){
              this.taxDialogRemarkText = globalData.taxDialogRemarkText3
            }else if(newVal.countrySite == 1){
              this.taxDialogRemarkText = globalData.taxDialogRemarkText8
            }else if(newVal.countrySite == 9){
              this.taxDialogRemarkText = globalData.taxDialogRemarkText9
            }
          }else{
            if(newVal.countrySite == 0){
              this.taxDialogRemarkText = globalData.taxDialogRemarkText4
            }else if(newVal.countrySite == 1){
              this.taxDialogRemarkText = globalData.taxDialogRemarkText5
            }else if(newVal.countrySite == 9){
              this.taxDialogRemarkText = globalData.taxDialogRemarkText6
            }
          }
            for(let i = 0; i < 1; i ++){
              this.taxDialogData.input[i].pla =
                newVal.sqbs == 0 ?
                '(物流双清包税)' : '(以自己税号自缴)'
            }
        }else if(arr3.includes(newVal.countrySite)){
          this.taxDialogData = ProfitInputNewModule.NEWTAXDATAAISA()
          this.taxDialogRemarkText =
            newVal.sqbs == 0 ?
            globalData.taxDialogRemarkText2 :
            globalData.taxDialogRemarkText1
            for(let i = 0; i < 2; i ++){
              this.taxDialogData.input[i].pla =
                newVal.sqbs == 0 ?
                '(物流双清包税)' : '(以自己税号自缴)'
            }
        }
        this.taxDialogDataLast = this.taxDialogData.input.pop()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.new{
  width: 1680px;
  &__title{
    display: flex;
    align-items: end;
    font-size: 18px;
    color: black;
    font-weight: bold;
  }
  &__tips{
    font-size: 12px;
    font-weight: normal;
    color: #fca605;
  }
  &-top{
    display: flex;
    justify-content: flex-end;
    &__name{
      margin: 0 5px;
      font-size: 14px;
    }
    &__tip{
      font-size: 12px;
      font-weight: lighter;
      color: #00a0c7;
    }
    &__value{
      color: #880015;
      font-weight: bold;
    }
  }
  &-input{
    &__title{
      font-size: 20px;
      font-weight: bold;
      color: #00a0c7;
      margin-left: 10px;
      margin-top: 10px;
    }
    &-module{
      display: flex;
      input[disabled],input:disabled,input.disabled{
        color: #e8e8e8;
        -webkit-text-fill-color: #c7b7b7;
        opacity: 1;
      }
      &-item{
        margin: 10px;
      }
      &__name{
        margin: 5px 0;
        font-weight: bold;
        color: black;
        &--tips{
          color: #00a0c7;
        }
      }
      &__input{
        width: 140px;
        padding: 4px 10px;
        outline: none;
        border-radius: 2px;
        border: 1px solid #7f9db9;
      }
      &-img{
        position: relative;
        margin-top: 10px;
        width: 140px;
        height: 140px;
        border: 1px solid #7f9db9;
        border-radius: 10px;
        &__add{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: inline-block;
          width: 76px;
          height: 76px;
          color: #ccc;
          position: relative;
          &::after, &::before{
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
          }
          &::before {
            width: 20px;
            border-top: 4px solid;
            margin: -2px 0 0 -10px;
          }
          &::after {
            height: 20px;
            border-left: 4px solid;
            margin: -10px 0 0 -2px;
          }
        }
        &__input{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 76px;
          height: 76px;
          opacity: 0;
          &:hover{
            cursor: pointer;
          }
        }
        &__image{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 140px;
          height: 140px;
        }
        &__text{
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          font-size: 12px;
          width: 120px;
          text-align: center;
        }
        &__close{
          position: absolute;
          top: 0;
          left: 88%;
          width: 20px;
          height: 20px;
          z-index: 1;
          transform: rotate(45deg);
          transition: color .25s;
          display: inline-block;
          color: rgb(160, 160, 160);
          position: relative;
          &:hover{
            color: #7f9db9;
            cursor: pointer;
          }
          &::after, &::before{
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
          }
          &::before {
            width: 12px;
            border-top: 2px solid;
            margin: -1px 0 0 -6px;
          }
          &::after {
            height: 12px;
            border-left: 2px solid;
            margin: -6px 0 0 -1px;
          }
        }
      }
    }
    &-bottom{
      display: flex;
      justify-content: end;
      &__btn{
        padding: 8px 20px;
        color: white;
        background: #00a0c7;
        margin-left: 10px;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
      }
    }
  }
  &-cal{
    display: flex;
    justify-content: space-between;
    padding: 2px 10px;
    &__divider{
      font-size: 18px;
      color: #818181;
      font-weight: bold;
      background: #99dcf3;
      margin: 10px ;
      padding: 5px 10px;
    }
    &-left{
      &-module{
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #8e8e8e
      }
    }
    &-bottom{
      font-size: 20px;
      font-weight: bold;
      color: #e01e1ef7;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 10px 35px 10px 10px;
      &__right{
        display: flex;
      }
      &__btn{
        font-size: 12px;
        background-color: #ff7f27;
        color: white;
        padding: 5px 10px;
        border-radius: 5px;
        margin-right: 5px;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
      }
    }
    &__title{
      color: #00a0c7;
      font-weight: bold;
      font-size: 18px;
    }
    &__block{
      display: inline-block;
      vertical-align: top;
      margin: 5px;
    }
    &__line{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px;
      font-size: 14px;
      position: relative;
    }
    &__line1{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 4px;
      font-size: 14px;
    }
    &__name{
      width: 240px;
      min-width: 192px;
      color: black;
      position: relative;
      &--selected{
        color: #FCA605;
      }
    }
    &__tip{
      font-weight: bold;
      color: #19acfd;
    }
    &__value{
      width: 100px;
      min-width: 74px;
      font-weight: bold;
      color: #e01e1ef7;
      position: relative;
    }
    &__icon{
      color: #444444;
      position: absolute;
      left: -15px;
    }
    &__img{
      width: 12px;
      transform: translate(0px, 1px);
    }
    &__detail{
      position: absolute;
      background-color: #dbedfc;
      top: 10px;
      left: 0px;
      color: black;
      font-size: 12px;
      z-index: 10;
      line-height: 15px;
      border: 1px solid #a8a8a8;
      border-radius: 8px;
      padding: 5px;
      width: 700px;
      &::after{
        content: '';
        position: absolute;
        left: 8px;
        top: -6px;
        width: 10px;
        height: 10px;
        margin-bottom: -10px;
        background: inherit;
        /*自动继承父元素的背景*/
        transform: rotate(45deg);
        border-left: 1px solid #a8a8a8;
        border-top: 1px solid #a8a8a8;
      }
    }
    &__detail1{
      width: 300px;
    }
    &__bottom{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      float: right;
      transform: translateY(-20px);
    }
    &__btn{
      color: white;
      background-color: #1c99fd;
      border: none;
      font-weight: bold;
      outline: none;
      padding: 10px 30px;
      font-size: 14px;
      border-radius: 3px;
      margin: 0 20px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
    &__down{
      position: absolute;
      right: 18px;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 8px solid black;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
  &-fun{
    display: flex;
    justify-content: end;
    &__btn{
      padding: 8px 20px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}

.calm{
  &-tax{
    &__title{
      font-size: 20px;
      font-weight: bold;
      color: black;
      padding: 0px 5px 10px;
    }
    &__subtitle{
      font-size: 14px;
      color: #ff7f17;
      font-weight: normal;
      margin-left: 5px;
    }
    &__module{
      border-top: 0.5px solid rgb(129, 129, 129);
      border-bottom: 1px dashed rgb(104, 104, 104);;
    }
    &__line{
      display: flex;
      justify-content: space-between;
      margin: 10px;
    }
    &__name{
      flex: 1;
      position: relative;
    }
    &__right{
      flex: 1;
      color: #00a0c7;
      position: relative;
      display: flex;
      justify-content: space-between;
    }
    &__value{
      position: relative;
      &--underline{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: -100%;
        color: #ff7f17;
        text-decoration: line-through;
      }
      &--underline1{
        left: -180%;
      }
    }
    &__remark{
      margin: 10px;
      line-height: 20px;
      font-size: 12px;
      color: rgb(0, 160, 199);
    }
    &__img{
      width: 12px;
      transform: translate(0px, 1px);
    }
    &__detail{
      position: absolute;
      background-color: #dbedfc;
      top: 10px;
      left: 0px;
      color: black;
      font-size: 12px;
      z-index: 10;
      line-height: 15px;
      border: 1px solid #a8a8a8;
      border-radius: 8px;
      padding: 5px;
      // width: 400px;
      &::after{
        content: '';
        position: absolute;
        left: 8px;
        top: -6px;
        width: 10px;
        height: 10px;
        margin-bottom: -10px;
        background: inherit;
        /*自动继承父元素的背景*/
        transform: rotate(45deg);
        border-left: 1px solid #a8a8a8;
        border-top: 1px solid #a8a8a8;
      }
    }
    &__detail1{
      width: 500px;
    }
  }
}
.input--prompt{
  border-color: red;
}
.input--disable{
  background: #f5f5f5;
}
</style>
